import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    if (localStorage.getItem("sw-sidebar-collapsed") === "1") {
      this.element.classList.add("collapsed")
    }
  }

  toggleCollapse() {
    const collapsed = this.element.classList.toggle("collapsed")
    localStorage.setItem("sw-sidebar-collapsed", collapsed ? "1" : "0")
  }

  openMobile() {
    this.element.classList.add("mobile-open")
    document.getElementById("sw-backdrop")?.classList.add("visible")
    document.body.style.overflow = "hidden"
  }

  closeMobile() {
    this.element.classList.remove("mobile-open")
    document.getElementById("sw-backdrop")?.classList.remove("visible")
    document.body.style.overflow = ""
  }
}
